import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";

class ThankYou extends React.Component {
  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="first-bg"></div>
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="dv-login-form dv-form">
                  <h1 className="section-heading border-heading">Thank you</h1>
                  <div className="successMsg text-center">
                    <img
                      src={require("assets/img/icons/thankyou.png")}
                      className="img-thankyou"
                      alt="safexpay-img"
                    />
                    <h4 className="my-4 px-md-2">
                      We have received your request and we will get back to you
                      soon.
                    </h4>
                  </div>

                  <div className="dv-bottom-bg mt-4">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default ThankYou;
